import React from 'react';
import {Select, Spin} from 'antd';
import {nameSort} from "../../common/sorters";

const Option = Select.Option;

const formattedUserDisplayName = user => (user.firstname || user.lastname) ? `${user.firstname} ${user.lastname}` + (user.email && ` (${user.email})`) : user.email;

export class UserSelect extends React.Component {
  constructor(props) {
    super(props);
    const { value } = this.props;
    this.state = {
      data: value ? [{text: 'Loading...', value}] : [],
      value: value,
      fetching: false,
    };
  }

  componentDidMount() {
    this.fetchUser();
  }

  fetchUser = (query, id) => {
    const { onSearch } = this.props;  // shape: (q, id) => promise of records
    this.setState({ data: [], fetching: true });
    onSearch(query, id).then(records => {
      const data = records
        .filter(user => user)
        .map(user => ({
          text: formattedUserDisplayName(user),
          value: user.contactuserid
        }));
      data.sort((a, b) => nameSort(a, b));
      this.setState({ data, fetching: false });
    });
  };

  handleChange = (value) => {
    this.setState((state, props) => {
      return {
        value: props.value || value,
        fetching: false,
      };
    });
    this.props.onChange && this.props.onChange(value);
  };

  render() {
    const { fetching, data, value: stateValue } = this.state;
    const { disabled, value } = this.props;
    return (
      <Select
        showSearch
        showArrow={false}
        defaultActiveFirstOption={false}
        value={value || stateValue}
        placeholder='Select user'
        notFoundContent={fetching ? <Spin size='small'/> : null}
        filterOption={(value, user) => new RegExp(value, 'i').test(user.props.children)}
        onChange={this.handleChange}
        style={{ width: '100%' }}
        disabled={disabled}
      >
        {data.map(d => <Option key={d.value}>{d.text}</Option>)}
      </Select>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Boilerplate/UserSelect.js